// Atoms
import * as drupal8 from './module-drupal8/drupal8';
import * as drupal8CustomAdmin from './module-drupal8-custom-admin/module-drupal8-custom-admin';
import * as jqueryUi from './module-jquery-ui/jquery-ui';
import * as libraries from './libraries/libraries';
export default {
  drupal8,
  drupal8CustomAdmin,
  jqueryUi,
  libraries,
};
